module.exports = __webpack_public_path__ + "img/developmentS.6bf0d29f.png";